import { Component, Input, OnInit } from '@angular/core';
import { FilterArrayPipe } from '@app/components/pipes/filter-array/filter-array.pipe';
import {
  NgClass,
  NgOptimizedImage,
  NgStyle,
  NgTemplateOutlet,
  TitleCasePipe,
} from '@angular/common';
import { SafePipe } from '@app/components/pipes/safe/safe.pipe';
import { ToParagraphPipe } from '@app/components/pipes/to-paragraph/to-paragraph.pipe';
import { ContainerModel } from '@app/models/server/layout.model';

@Component({
  selector: 'app-activity-information-card',
  templateUrl: './activity-information-card.component.html',
  styleUrls: ['./activity-information-card.component.scss'],
  imports: [
    FilterArrayPipe,
    NgOptimizedImage,
    NgTemplateOutlet,
    SafePipe,
    TitleCasePipe,
    ToParagraphPipe,
    NgClass,
    NgStyle,
  ],
  standalone: true,
})
export class ActivityInformationCardComponent implements OnInit {
  @Input() compData: {
    container: ContainerModel;
  };

  clampRow = 5;
  readMore: boolean;

  constructor() {}

  ngOnInit() {}
}
